var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBybit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 71,
    viewBox: "0 0 180 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.105 52.706V6.67651H137.357V52.706H128.105Z",
    fill: "#F7A600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.276 66.3789H0.441162V20.3494H19.4784C28.7306 20.3494 34.1217 25.3918 34.1217 33.2794C34.1217 38.385 30.6593 41.6845 28.2629 42.7831C31.1234 44.0754 34.785 46.9839 34.785 53.1285C34.785 61.7239 28.7306 66.3789 20.276 66.3789ZM18.7461 28.3672H9.69331V38.9695H18.7461C22.6725 38.9695 24.8695 36.8358 24.8695 33.6666C24.8695 30.501 22.6725 28.3672 18.7461 28.3672ZM19.3443 47.0508H9.69331V58.3645H19.3443C23.5389 58.3645 25.5329 55.7801 25.5329 52.6743C25.5329 49.5721 23.5352 47.0508 19.3443 47.0508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0052 47.5015V66.3789H53.8183V47.5015L39.5739 20.3494H49.6236L58.477 38.9026L67.1963 20.3494H77.2461L63.0052 47.5015Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.476 66.3789H83.6415V20.3494H102.679C111.931 20.3494 117.322 25.3918 117.322 33.2794C117.322 38.385 113.86 41.6845 111.463 42.7831C114.324 44.0754 117.986 46.9839 117.986 53.1285C117.986 61.7239 111.931 66.3789 103.476 66.3789ZM101.947 28.3672H92.8937V38.9695H101.947C105.873 38.9695 108.07 36.8358 108.07 33.6666C108.07 30.501 105.873 28.3672 101.947 28.3672ZM102.545 47.0508H92.8937V58.3645H102.545C106.739 58.3645 108.733 55.7801 108.733 52.6743C108.733 49.5721 106.739 47.0508 102.545 47.0508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.177 28.3672V66.3824H157.925V28.3672H145.544V20.3494H179.558V28.3672H167.177Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 179.118,
    height: 70,
    fill: "white",
    transform: "translate(0.441162 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybit);
export default __webpack_public_path__ + "static/media/bybit.121f08b0e944868509f51576912afbf5.svg";
export { ForwardRef as ReactComponent };